import { Component, OnInit, AfterViewInit } from '@angular/core';

declare var jQuery: any;

@Component({
	moduleId: module.id,
	selector: "sidebar-right",
	templateUrl: '../shell-templates/sidebar-right.component.html'
})

export class SidebarRightComponent {
  title = "Menu";

	constructor(
	) { }

	ngOnInit(): void {
	}

	ngAfterViewInit() {
    // if (jQuery.AdminLTE && jQuery.AdminLTE.controlSidebar) {
    //   jQuery.AdminLTE.controlSidebar.activate();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/app/shell/shell-components/sidebar-right.component.ts